import { render, staticRenderFns } from "./InputSwitch.vue?vue&type=template&id=bdacfafa&scoped=true"
import script from "./InputSwitch.ts?vue&type=script&lang=ts&external"
export * from "./InputSwitch.ts?vue&type=script&lang=ts&external"
import style0 from "./InputSwitch.scss?vue&type=style&index=0&id=bdacfafa&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdacfafa",
  null
  
)

export default component.exports